/**
 * master
 *  ## 공통으로 사용되는 데이터를 등록,조회,수정,삭제한다. 
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { Failure } from '../model/failure';
import { Page } from '../model/page';
import { PagePost } from '../model/pagePost';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PageService {

    protected basePath = 'http://bstore-dev-nlb-to-backends-03c7de26a0c53e22.elb.ap-northeast-2.amazonaws.com:9900/master/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 전체 page 조회(삭제페이지포함)
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pageGet(observe?: 'body', reportProgress?: boolean): Observable<Array<Page>>;
    public pageGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Page>>>;
    public pageGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Page>>>;
    public pageGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        return this.httpClient.get<Array<Page>>(`${this.basePath}/page`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * page 삭제
     * 등록된 page를 삭제한다.
     * @param page_id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pagePageIdDelete(page_id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pagePageIdDelete(page_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pagePageIdDelete(page_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pagePageIdDelete(page_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (page_id === null || page_id === undefined) {
            throw new Error('Required parameter page_id was null or undefined when calling pagePageIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/page/${encodeURIComponent(String(page_id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * page 조회
     * 등록된 page를 조회한다.
     * @param page_id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pagePageIdGet(page_id: string, observe?: 'body', reportProgress?: boolean): Observable<Page>;
    public pagePageIdGet(page_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Page>>;
    public pagePageIdGet(page_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Page>>;
    public pagePageIdGet(page_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (page_id === null || page_id === undefined) {
            throw new Error('Required parameter page_id was null or undefined when calling pagePageIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        return this.httpClient.get<Page>(`${this.basePath}/page/${encodeURIComponent(String(page_id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * page 수정
     * 등록된 page를 수정한다.
     * @param page_id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pagePageIdPut(page_id: string, body: PagePost, observe?: 'body', reportProgress?: boolean): Observable<Page>;
    public pagePageIdPut(page_id: string, body: PagePost, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Page>>;
    public pagePageIdPut(page_id: string, body: PagePost, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Page>>;
    public pagePageIdPut(page_id: string, body: PagePost, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (page_id === null || page_id === undefined) {
            throw new Error('Required parameter page_id was null or undefined when calling pagePageIdPut.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling pagePageIdPut.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Page>(`${this.basePath}/page/${encodeURIComponent(String(page_id))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * page 등록
     * page를 등록한다.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pagePost(body: PagePost, observe?: 'body', reportProgress?: boolean): Observable<Page>;
    public pagePost(body: PagePost, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Page>>;
    public pagePost(body: PagePost, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Page>>;
    public pagePost(body: PagePost, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling pagePost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Page>(`${this.basePath}/page`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
